var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS2N2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 50 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_139)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 52.6756C38.531 52.6756 49.5 41.0924 49.5 26.8036C49.5 12.5149 38.531 0.931641 25 0.931641C11.469 0.931641 0.5 12.5149 0.5 26.8036C0.5 41.0924 11.469 52.6756 25 52.6756Z",
    fill: "#7B6AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0739 35.9316V35.3556C19.0739 28.4196 27.6179 28.9956 27.6179 24.8436C27.6179 23.0916 26.5859 22.0356 24.6659 22.0356C22.5539 22.0356 21.5219 23.1156 21.2339 24.8916H19.0499C19.4579 21.9876 21.4019 20.2116 24.6899 20.2116C28.0499 20.2116 29.7779 22.2036 29.7779 24.8196C29.7779 29.8116 22.1459 29.7636 21.2579 34.2516H29.9459V35.9316H19.0739Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 51.744,
    fill: "white",
    transform: "translate(0.5 0.931641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS2N2);
export default __webpack_public_path__ + "static/media/HomeS2N2.df402ec92741e44d1f41838f9672af3d.svg";
export { ForwardRef as ReactComponent };